'use client';

import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useRouter, useSearchParams } from 'next/navigation';
import { useForm } from 'react-hook-form';
import styles from './FaqSearchForm.module.scss';
import FormText from '@/components/form/FormText/FormText';
import FaIcon from '@/components/icon/FaIcon/FaIcon';

function FaqSearchForm() {
  const router = useRouter();
  const searchParams = useSearchParams();

  const { handleSubmit, getValues, control } = useForm({
    defaultValues: {
      q: searchParams?.get('q') || '',
    },
  });

  const submit = async () => {
    const q = getValues('q');
    if (q) {
      router.push(`/faq?q=${q}`);
    } else {
      router.push(`/faq`);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(submit)}>
        <FormText
          name='q'
          control={control}
          placeholder='質問を検索'
          prefix={
            <div className={styles.searchIcon}>
              <FaIcon icon={faSearch} size='xl' />
            </div>
          }
          outlined
          isSmall={true}
        ></FormText>
      </form>
    </div>
  );
}

export default FaqSearchForm;
